import { makeStyles, createStyles, Theme } from "@material-ui/core/styles"
import bgImage from "assets/img/arif-hero.jpg"
import bgBlog from "assets/img/article.jpg"

export const AppStyles = makeStyles((theme: Theme) =>
  createStyles({
    fixed: {
      width: "100%",
      position: "fixed",
      top: 0,
      zIndex: 1,
    },
    root: {
      maxWidth: 390,
    },
    marginTen: {
      margin: 10,
    },
    avatarContainer: {
      display: "flex",
      justifyContent: "center",
    },
    aboutMeCont: {
      display: "flex !important",
    },
    avatar: {
      borderRadius: "25px",
      width: "200px !important",
      height: "200px !important",
      margin: "0 20px",
    },
    aboutMeText: {
      width: "66.66% !important",
    },
    topPadding: {
      paddingTop: "64px",
    },
    container: {
      maxHeight: "700px",
      backgroundColor: "#00b894",
    },
    icon: {
      marginRight: theme.spacing(2),
    },
    heroOuter: {
      position: "relative",
      backgroundImage: `url(${bgImage})`,
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      padding: "15rem 0 10rem",
      // backgroundImage:
      // "linear-gradient(180deg, rgba(225,112,85,1) 0%, rgba(253,203,110,1) 100%);",
    },
    heroInner: {
      padding: "1rem",
      backgroundColor: "rgba(223, 230, 233, 0.8)",
      borderRadius: "25px",
    },
    heroTitle: {
      fontSize: "3.75rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    heroDesc: {
      fontSize: "1.5rem",
    },
    myBlogOuter: {
      paddingTop: "100px",
      position: "relative",
      backgroundImage:
        "linear-gradient(180deg, rgba(225,112,85,1) 0%, rgba(253,203,110,1) 100%);",
    },
    blogPageOuter: {
      position: "relative",
      backgroundImage: `url(${bgBlog})`,
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      padding: "15rem 0 10rem",
      // backgroundImage:
      // "linear-gradient(180deg, rgba(225,112,85,1) 0%, rgba(253,203,110,1) 100%);",
    },
    featuredOuter: {
      padding: "20px 0",
    },
    extraVerticalPadding: {
      padding: "80px 0",
    },
    textContainer: {
      width: "60%",
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    cardMedia: {
      paddingTop: "56.25%", // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    footer: {
      backgroundColor: "#2d3436",
      padding: theme.spacing(6),
      color: "#ffffff",
    },
    flexContainer: {
      display: "flex !important",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    paddingNone: {
      padding: "0 !important",
    },
    flexSpaceAround: {
      display: "flex !important",
      justifyContent: "space-around",
    },
    paddingBottom: {
      paddingBottom: "2rem",
    },
    footerTitle: {
      fontSize: "1rem !important",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    footerDesc: {
      fontSize: "0.75rem !important",
      textAlign: "center",
      fontFamily: "Quicksand, Sans-Serif !important",
    },
    "@media screen and (min-width: 320px)": {
      heroTitle: {
        fontSize: "2rem !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      heroDesc: {
        fontSize: "1rem !important",
        textAlign: "center !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      footerTitle: {
        fontSize: "1rem !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      footerDesc: {
        fontSize: "0.75rem !important",
        textAlign: "center !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      aboutMeCont: {
        display: "block !important",
      },
      aboutMeText: {
        width: "100% !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      avatar: {
        margin: "20px auto",
      },
    },
    "@media screen and (min-width: 475px)": {
      heroTitle: {
        fontSize: "3.75rem !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      heroDesc: {
        fontSize: "1.5rem !important",
        textAlign: "left !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      footerTitle: {
        fontSize: "2rem !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      footerDesc: {
        fontSize: "1rem !important",
        textAlign: "center !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      aboutMeCont: {
        display: "flex !important",
      },
      aboutMeText: {
        width: "66.66% !important",
        fontFamily: "Quicksand, Sans-Serif !important",
      },
      avatar: {
        borderRadius: "25px",
        width: "200px !important",
        height: "200px !important",
        margin: "0 20px",
      },
    },
  })
)
